/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellValueWithCountsDeprecated } from "./CellValueWithCountsDeprecated";
export const CellsResponseDataDeprecated = core.serialization.record(core.serialization.string(), core.serialization.list(CellValueWithCountsDeprecated));
